
import userService  from '../services/userService';

export const changePasswordPost = async (params, updatedData) => {
  const res = await userService.changePassword(params, updatedData);
  return res;
};





